
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DataLayerService {
  constructor() {}

  addDataToDataLayer(data: any) {
   
    window.dataLayer = window.dataLayer || [];

   
    window.dataLayer.push(data);
  }

  getCookies() {
    const checkCookies = setInterval(() => {
      window.dataLayer = window.dataLayer || [];
      if (window.dataLayer.find(item => item.hasOwnProperty('event') && item.event === 'gtm.click')) {
        localStorage.setItem('acceptCookies-AperturaDigital', 'true');
        clearInterval(checkCookies);
      }
    }, 1000);
  }
}